import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/purchase_subscriptions',
    name: 'PurchaseSubscriptions',
    component: {
      name: 'AdminPurchaseSubscription',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'purchase_subscription',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminPurchaseSubscriptionIndex',
        component: () => import('../views/PurchaseSubscriptionAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminPurchaseSubscriptionNew',
        component: () => import('../views/PurchaseSubscriptionAdminInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminPurchaseSubscriptionIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminPurchaseSubscriptionShow',
        component: () => import('../views/PurchaseSubscriptionAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminPurchaseSubscriptionIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminPurchaseSubscriptionDetails',
            component: () => import('../views/PurchaseSubscriptionAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminPurchaseSubscriptionIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminPurchaseSubscriptionEdit',
            component: () => import('../views/PurchaseSubscriptionAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminPurchaseSubscriptionDetails' },
            },
          },
          {
            path: 'attachments',
            name: 'AdminPurchaseSubscriptionAttachments',
            component: () => import('../views/attachment/PurchaseSubscriptionAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminPurchaseSubscriptionIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'attachments/edit',
            name: 'AdminPurchaseSubscriptionAttachmentsEdit',
            component: () => import('../views/attachment/PurchaseSubscriptionAttachmentsInput.vue'),
            meta: {
              backRoute: { name: 'AdminPurchaseSubscriptionAttachments' },
              resource: 'attachment',
              action: 'edit',
            },
          },
          {
            path: 'processed_document_connections',
            name: 'AdminPurchaseSubscriptionProcessedDocumentConnections',
            component: () => import('../views/processedDocumentConnection/PurchaseSubscriptionProcessedDocumentConnections.vue'),
            meta: {
              backRoute: { name: 'AdminPurchaseSubscriptionIndex' },
              resource: 'incoming_invoice',
            },
          },
          {
            path: 'logs',
            name: 'AdminPurchaseSubscriptionLogs',
            component: () => import('../views/log/PurchaseSubscriptionLogs.vue'),
            meta: {
              backRoute: { name: 'AdminPurchaseSubscriptionIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));